import { connect } from 'react-redux';

import { SimpleModalId } from 'constants/modalId';
import { ClippingPlatformState } from 'store/clippingPlatformState';
import { ClientsUserPasswordModalBody } from './password-modal-body';

const mapStateToProps = (state: ClippingPlatformState) => {
  const modalData = state.appStatus.modals[SimpleModalId.ClientsUserSuccessMessage];

  return {
    user: (modalData.props || {}).user || {},
  };
};

export const ClientsUserPasswordModalBodyContainer = connect(mapStateToProps)(ClientsUserPasswordModalBody);
